module.exports = __webpack_public_path__ + "media/packs/site/assets/images/fr/fr_section01_img_pc-d27e137ed1b54865b6309393dea8368f.png";